import React from 'react';

/**
 * Hook that helps alleviate difference between how document object behaves in the Canvas app that is single page application (SPA)
 * and the published sites that are not SPA.
 */
export const useEnsureNewDocumentOnPageSwitch = ({
  pageId,
  isPageLoading,
}: {
  pageId: string | undefined;
  isPageLoading: boolean | undefined;
}) => {
  const isInitialLoad = React.useRef(true);
  const prevIsPageLoading = React.useRef(isPageLoading);

  React.useLayoutEffect(() => {
    const wasPageLoading = prevIsPageLoading.current;
    prevIsPageLoading.current = isPageLoading;

    if (!pageId) return;

    if (isInitialLoad.current) {
      // if this is the initial load of the page don't reload
      isInitialLoad.current = false;
    } else if (isPageLoading && !wasPageLoading) {
      // when user is switching pages we need to trigger full reload, so we get new `document` object created for the new page
      // as our users published sites are not SPA and we need to make sure that we are not leaking any data between pages
      window.location.reload();
    }
  }, [isPageLoading, pageId]);
};
